import localforage from 'localforage';

export const LOCAL_CONFIG_KEY = 'config';

type UserConfig = {
  dismissedWelcomeBanner: boolean;
};

const defaultConfig: UserConfig = {
  dismissedWelcomeBanner: false,
};

export const getUserConfigFromLocal = async () => {
  // TO-DO: use zod to validate?
  try {
    const userConfig: UserConfig =
      (await localforage.getItem(LOCAL_CONFIG_KEY)) || defaultConfig;
    return { error: false, data: userConfig };
  } catch (error) {
    // TO-DO: Deal with this error
    console.log('Error getting config from local:', error);
    return { error: true, data: {} as UserConfig };
  }
};

export const setUserConfigToLocal = async (userConfig: Partial<UserConfig>) => {
  try {
    const existingConfig = await getUserConfigFromLocal();
    const newConfig = { ...existingConfig.data, ...userConfig };
    await localforage.setItem(LOCAL_CONFIG_KEY, newConfig);
    return { error: false, data: newConfig };
  } catch (error) {
    // TO-DO: Deal with this error
    console.log('Error setting config to local:', error);
    return { error: true, data: {} as UserConfig };
  }
};
